import { languageCodes } from "../../../config/index";

const normalizeFloat = (value) => {
  return parseFloat(value ? value : "0");
};

export const fixDecimal = (n, decimal = 2) => {
  return n.toFixed(decimal);
};

export const getTotals = (data) => {
  // console.log("Data", data);
  const initialTotals = Array.from(Array(7)).map(() => ({ hours: 0 }));
  const totals = {};
  let totalHours = 0;
  for (let i = 0; i < initialTotals.length; ++i) {
    totals[`day${i + 1}`] = initialTotals[i];
  }
  if (!data) return { totals, totalHours };
  for (let record of data) {
    totals["day1"].hours += normalizeFloat(record.day1);
    totals["day2"].hours += normalizeFloat(record.day2);
    totals["day3"].hours += normalizeFloat(record.day3);
    totals["day4"].hours += normalizeFloat(record.day4);
    totals["day5"].hours += normalizeFloat(record.day5);
    totals["day6"].hours += normalizeFloat(record.day6);
    totals["day7"].hours += normalizeFloat(record.day7);
  }

  for (let i = 0; i < 7; ++i) {
    const index = i + 1;
    totalHours += totals[`day${index}`].hours;
    totals[`day${index}`].hours = fixDecimal(totals[`day${index}`].hours);
  }
  // totalHours = fixDecimal(totalHours);
  // console.log("New", totals);
  return { totals, totalHours };
  // return totals;
};

export const getErrors = (errors, index, field) => {
  // return false;
  if (!errors) return "";
  if (!errors[index]) return "";
  if (!errors[index][field]) return "";
  // return errors[index][field];
  return true;
};

export const getWeekError = (errors, field) => {
  if (!errors) return false;
  if (!errors[field]) return false;
  return errors[field];
};

export const getActivityGroupByLanguage = (language, activityGroups) => {
  // return activityGroups[language];
  const allActivityGroups = activityGroups[language];
  if (allActivityGroups !== undefined) {
    return allActivityGroups;
  } else {
    return activityGroups[languageCodes.english];
  }
};

export const getJobFamiliesByLanguage = (language, jobFamilies) => {
  // console.log('all job families', jobFamilies)
  const allJobFamilies = jobFamilies[language];
  if (allJobFamilies !== undefined) {
    return allJobFamilies;
  } else {
    return jobFamilies[languageCodes.english];
  }
};

export const deepEqual = (object1, object2) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if (
      (areObjects && !deepEqual(val1, val2)) ||
      (!areObjects && val1 !== val2)
    ) {
      return false;
    }
  }

  return true;
};

const isObject = (object) => {
  return object != null && typeof object === "object";
};
